// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-step .ant-steps-item-icon {
  background-color: #96f5d0 !important;
  border-color: #96f5d0 !important;
  color: white !important;
}

.custom-step .ant-steps-item-finish .ant-steps-item-icon {
  background-color: #96f5d0 !important;
  border-color: #96f5d0 !important;
  color: white !important;
}

.custom-step .ant-steps-item-finish .ant-steps-item-icon .anticon {
  color: white !important;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/stepProgress/stepProgress.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".custom-step .ant-steps-item-icon {\r\n  background-color: #96f5d0 !important;\r\n  border-color: #96f5d0 !important;\r\n  color: white !important;\r\n}\r\n\r\n.custom-step .ant-steps-item-finish .ant-steps-item-icon {\r\n  background-color: #96f5d0 !important;\r\n  border-color: #96f5d0 !important;\r\n  color: white !important;\r\n}\r\n\r\n.custom-step .ant-steps-item-finish .ant-steps-item-icon .anticon {\r\n  color: white !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
